import NFitGroupHistoryChart from "../Chart/nfit-history-group";
import NFitGroupHistogramChart from "../Chart/nfit-group-histogram";

import "./group-summary.css";
import { useEffect, useState } from 'react';
export default function GroupSummary() {
    let [daysBack, setDaysBack] = useState<number>(-1);
    let [start, setStart] = useState<Date>(new Date('1900-01-01'));

    const setStartParameter = (days: number) => {
        setDaysBack(days);
    };

    useEffect(() => {
        const newDate: Date = daysBack === -1 ? new Date('1900-01-01') : new Date();
        if (daysBack !== -1) newDate.setDate(new Date().getDate() - daysBack);
        setStart(newDate);
    }, [daysBack]);

    return (
        <>
        <div className="drop-shadow-content-box nFitScores">
            <div className="controls">
                <button className={daysBack === -1 ? "timePeriod selected" : "timePeriod"} onClick={() => setStartParameter(-1)}>all time</button>
                <button className={daysBack === 365 ? "timePeriod selected" : "timePeriod"} onClick={() => setStartParameter(365)}>1y</button>
                <button className={daysBack === 30 ? "timePeriod selected" : "timePeriod"} onClick={() => setStartParameter(30)}>1m</button>
                <button className={daysBack === 7 ? "timePeriod selected" : "timePeriod"} onClick={() => setStartParameter(7)}>1wk</button>
            </div>
            <div className="nFitGraph">
                <NFitGroupHistoryChart start={start} />
            </div>
        </div>
        <div className="drop-shadow-content-box nFitScores">
            <div className="nFitGraph">
                <NFitGroupHistogramChart />
            </div>
        </div>
        </>
    );
}